module.exports = __webpack_public_path__ + "static/img/card.46e41f85.jpg";